module.exports = __webpack_public_path__ + "static/media/tokenlon.92e5abed.svg";